import React from "react";
import { useSelector } from "react-redux";
import SwalAlertComp from "../../../SwalAlert";
import { getRCapiAuthUrl } from "helpers/Sources/rcapi/rcapisource";
import LoginButton from "../../../molecules/LoginButton";
import { ExtractedParams } from "../../../molecules/LoginButton/LoginButton.types";
import { RedditCapiOwnProps } from "./RedditCapi.types";

const ReconnectReddit = ({
    label,
    setAuthData,
    isLoading,
}: RedditCapiOwnProps) => {
    const language = useSelector(
        (state: any) => state.languagesState.languages,
    );

    const getAuthUrl = async () => {
        const response = await getRCapiAuthUrl();
        if (response.status) {
            return response.data;
        }
        SwalAlertComp({
            title: language?.delete_swal_modal?.failed ?? "Failed",
            message: response.message,
            icon: "error",
        });
        return null;
    };

    const handleSuccess = (data: any) => {
        setAuthData?.({ code: data.code });
    };

    return (
        <div className="w-full">
            <LoginButton
                code="reddit"
                getAuthUrl={getAuthUrl}
                paramNames={["code"]}
                onSuccess={handleSuccess}
                dataTransform={(params: ExtractedParams) => ({
                    code: params.code,
                })}
                logoSrc="/assets/images/typeImages/reddit-capi.png"
                buttonText={label}
                isLoadingExternal={isLoading}
            />
        </div>
    );
};

export default ReconnectReddit;
